import React from 'react';
import { LucideIcon } from 'lucide-react';

interface WorkspaceHeaderProps {
  title: string;
  icon: LucideIcon;
  description?: string;
}

export default function WorkspaceHeader({ title, icon: Icon, description }: WorkspaceHeaderProps) {
  return (
    <div className="mb-6 pb-4 border-b border-gray-200">
      <div className="flex items-center space-x-3">
        <div className="p-2 bg-blue-50 rounded-lg">
          <Icon className="w-5 h-5 text-blue-500" />
        </div>
        <div>
          <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
          {description && (
            <p className="text-sm text-gray-500 mt-1">{description}</p>
          )}
        </div>
      </div>
    </div>
  );
}